// Route Pages
const ForgotPassword = () => import('../../../components/common/pages/ForgotPassword.vue')
const RecoveryEmail = () => import('../../../components/common/pages/RecoveryEmail.vue')
const ResetPassword = () => import('../../../components/common/pages/ResetPassword.vue')
const SecureAccount = () => import('../../../components/common/pages/SecureAccount.vue')
const VerificationCode = () => import('../../../components/common/pages/VerificationCode.vue')
const VerificationMethod = () => import('../../../components/common/pages/VerificationMethod.vue')

export default () => {
  return [
    {
      path: '',
      name: 'ForgotPassword',
      component: ForgotPassword,
      props: true
    },
    {
      path: 'Email',
      name: 'RecoveryEmail',
      component: RecoveryEmail,
      props: true
    },
    {
      path: 'Reset',
      name: 'ResetPassword',
      component: ResetPassword,
      props: true
    },
    {
      path: 'SecureAccount',
      name: 'SecureAccount',
      component: SecureAccount,
      props: true
    },
    {
      path: 'Code',
      name: 'ForgotPasswordVerificationCode',
      component: VerificationCode,
      props: true
    },
    {
      path: 'VerificationMethod',
      name: 'ForgotPasswordVerificationMethod',
      component: VerificationMethod,
      props: true
    }
  ]
}
